import { ReactNode } from 'react';
import { breakpoints } from 'styles';

interface Props {
  children: ReactNode;
}

const EditorBlockCustomControls = ({ children }: Props) => (
  <div className="editor-block-custom-controls">
    {children}

    <style jsx>{`
      .editor-block-custom-controls {
        bottom: 10px;
        left: 10px;
        position: absolute;
        visibility: hidden;
      }

      @media (max-width: ${breakpoints.medium - 1}px) {
        .editor-block-custom-controls {
          padding-bottom: 38px;
        }
      }
    `}</style>
  </div>
);

export default EditorBlockCustomControls;
